import { render, staticRenderFns } from "./scoreWrapper.vue?vue&type=template&id=c05b593e&scoped=true"
import script from "./scoreWrapper.vue?vue&type=script&lang=js"
export * from "./scoreWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05b593e",
  null
  
)

export default component.exports